import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createVNode as _createVNode, Fragment as _Fragment, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["id", "type", "name", "value", "disabled"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["for"]
const _hoisted_6 = { class: "answer-tip" }
const _hoisted_7 = { class: "text answer-tip-text" }
const _hoisted_8 = ["id", "type", "name", "value"]
const _hoisted_9 = {
  key: 0,
  class: "answer-text text"
}
const _hoisted_10 = { key: 1 }

import { defineComponent, ref } from "vue";
import Tooltip from "./../Tooltip.vue";
import Icon from "./../Icon/Icon.vue";
import { store } from "./../../store";
import _ from "lodash";

type AnswerProps = {
  question: {
    type: string;
    name: string;
    choices: any;
  };
  answer?: {
    tip: string;
    key: string;
    text: string;
    image?: string;
    bodyPart?: string[];
    icon?: { active: string; selected: string };
    complement?: { name: string; label: string };
  };
};

export default /*#__PURE__*/_defineComponent({
  __name: 'Answers',
  props: {
    question: null,
    answer: null
  },
  emits: {
  change: (question) => question,
},
  setup(__props: any, { emit }) {

const { question, answer } = __props as {
  question: {
    type: string;
    name: string;
    choices: any;
  };
  answer?: {
    tip: string;
    key: string;
    text: string;
    image?: string;
    bodyPart?: string[];
    icon?: { active: string; selected: string };
    complement?: { name: string; label: string };
  };
}

defineComponent({
  name: "Answers",
});





const checked = ref(false);

const handleCheckboxChange = (e) => {
  checked.value = e.target.checked;
};

const onRadioChange = (question) => {
  emit("change", question);
};

const getSelectedBodyPart = (answer: any) => {
  if (!!answer.bodyPart) {
    return answer?.bodyPart?.includes(store.bodyPart);
  }
  return true
};  

return (_ctx: any,_cache: any) => {
  const _component_n_input = _resolveComponent("n-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "default"),
    (__props.question.type === 'checkbox' && getSelectedBodyPart(__props.answer))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("label", {
            class: _normalizeClass(["answer text", {
        'answer-circle': __props.answer?.icon,
        'answer-selected': checked.value,
      }]),
            for: __props.answer?.key || __props.answer?.text
          }, [
            _createTextVNode(_toDisplayString(__props.answer?.text) + " ", 1),
            (__props.answer?.tip)
              ? (_openBlock(), _createBlock(Tooltip, { key: 0 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.answer?.tip), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 10, _hoisted_2),
          _withDirectives(_createElementVNode("input", {
            class: "hidden",
            id: __props.answer?.key || __props.answer?.text,
            type: __props.question.type,
            name: __props.question.type === 'checkbox' ? __props.answer?.text : __props.question.name,
            value: __props.answer?.key || __props.answer?.text,
            disabled: _unref(store)[__props.question.name].length === __props.question.choices && !checked.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(store)[__props.question.name]) = $event)),
            onChange: handleCheckboxChange
          }, null, 40, _hoisted_3), [
            [_vModelDynamic, _unref(store)[__props.question.name]]
          ])
        ]))
      : _createCommentVNode("", true),
    (__props.question.type === 'radio' && getSelectedBodyPart(__props.answer))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("label", {
            class: _normalizeClass(["answer text", {
        'answer-circle': __props.answer?.icon,
        'answer-selected':
          _unref(store)[__props.question.name] === (__props.answer?.key || __props.answer?.text),
      }]),
            for: __props.answer?.key || __props.answer?.text
          }, [
            (__props.answer?.icon)
              ? (_openBlock(), _createBlock(Icon, {
                  key: 0,
                  name: 
          _unref(store)[__props.question.name] === (__props.answer?.key || __props.answer?.text)
            ? __props.answer?.icon?.selected
            : __props.answer?.icon?.active
        
                }, null, 8, ["name"]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(__props.answer?.text) + " ", 1),
                  (__props.answer?.tip)
                    ? (_openBlock(), _createBlock(Tooltip, { key: 0 }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_6, [
                            _createVNode(Icon, {
                              name: __props.answer?.image
                            }, null, 8, ["name"]),
                            _createElementVNode("p", _hoisted_7, _toDisplayString(__props.answer?.tip), 1)
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 64))
          ], 10, _hoisted_5),
          _withDirectives(_createElementVNode("input", {
            class: "hidden",
            id: __props.answer?.key || __props.answer?.text,
            type: __props.question.type,
            name: __props.question.name,
            value: __props.answer?.key || __props.answer?.text,
            onChange: onRadioChange,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(store)[__props.question.name]) = $event))
          }, null, 40, _hoisted_8), [
            [_vModelDynamic, _unref(store)[__props.question.name]]
          ]),
          (__props.answer?.icon)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                _createTextVNode(_toDisplayString(__props.answer.text) + " ", 1),
                (__props.answer.tip)
                  ? (_openBlock(), _createBlock(Tooltip, { key: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(__props.answer.tip), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (__props.answer?.complement)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_n_input, {
                  class: "answer-textinput",
                  type: "text",
                  value: _unref(store)[__props.answer?.complement.name],
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(store)[__props.answer?.complement.name]) = $event)),
                  size: "large",
                  round: "",
                  placeholder: __props.answer?.complement?.label
                }, null, 8, ["value", "placeholder"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})